<template>
  <div class="q-gutter-sm">
    <q-radio :model-value="valueString" val="all" label="All" @update:model-value="all" />
    <q-radio :model-value="valueString" val="pre" label="Pre Loss" @update:model-value="pre" />
    <q-radio :model-value="valueString" val="post" label="Post Loss" @update:model-value="post" />
    <div>
      <radio-date-range-picker
        :model-value="rangePickerValue"
        val="custom"
        label="Custom"
        @update:modelValue="custom"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DateRange, OpenDateRange } from '@/type';
import RadioDateRangePicker from '@/components/form/RadioDateRangePicker.vue';
import {
  getPreLossRange, isPreLossRange,
  isPostLossRange, getPostLossRange,
} from '../../client/client';

export default defineComponent({
  emits: ['update:modelValue'],
  components: {
    RadioDateRangePicker,
  },
  props: {
    modelValue: {
      type: Object as () => OpenDateRange,
      required: true,
    },
    dateOfLoss: {
      type: String,
      required: true,
    },
  },
  computed: {
    valueString(): string {
      if (this.modelValue.start && this.modelValue.end) {
        return 'custom';
      }
      if (isPreLossRange(this.dateOfLoss, this.modelValue)) {
        return 'pre';
      }
      if (isPostLossRange(this.dateOfLoss, this.modelValue)) {
        return 'post';
      }
      return 'all';
    },
    rangePickerValue(): DateRange|null {
      if (this.modelValue.start && this.modelValue.end) {
        return {
          start: this.modelValue.start,
          end: this.modelValue.end,
        };
      }
      return null;
    },
  },
  methods: {
    all() {
      this.$emit('update:modelValue', {});
    },
    pre() {
      this.$emit('update:modelValue', getPreLossRange(this.dateOfLoss));
    },
    post() {
      this.$emit('update:modelValue', getPostLossRange(this.dateOfLoss));
    },
    custom(range: DateRange) {
      this.$emit('update:modelValue', {
        start: range.start,
        end: range.end,
      });
    },
  },
});
</script>
